const lodash = require('lodash')
const mutations = {
  setLoading(state, value) {
    state.loading = value
  },
  setNotFound(state, notFound) {
    state.notFound = notFound
  },
  setNavigationDrawer(state, navigationDrawer) {
    state.navigationDrawer = navigationDrawer
  },
  setSnackbar(
    state,
    { isDisplayed = true, position, message, type, timeout = 5000 }
  ) {
    const snackbar = { isDisplayed, position, message, type, timeout }
    state.snackbar = snackbar
  },
  setDialog(
    state,
    { isDisplayed = true, maxWidth = '350', title, message, error }
  ) {
    const dialog = { isDisplayed, maxWidth, title, message, error }
    state.dialog = dialog
  },
  setProgress(
    state,
    {
      isDisplayed = true,
      height = 20,
      color = 'progress',
      movement = true,
      message,
      link,
      messageParams,
      single,
    }
  ) {
    const newItem = {
      isDisplayed,
      message,
      height,
      color,
      movement,
      link,
      messageParams,
      single,
    }
    if (
      newItem.message === 'updatingNotificationsText' &&
      newItem.isDisplayed === false
    ) {
      // si existe, buscar y eliminar el mensaje ya existente en el array
      const index = state.progress.findIndex((item) => {
        return (
          item.message === 'updatingNotificationsText' &&
          item.isDisplayed === true
        )
      })
      if (index !== -1) {
        state.progress.splice(index, 1)
      }
    }

    if (newItem.single === true) {
      const index = state.progress.findIndex((item) => {
        return item.single === true
      })
      if (index !== -1) {
        state.progress.splice(index, 1)
      }
    }

    state.progress.push(newItem)
  },
  setBrand(state, brand) {
    state.brand = brand
  },
  setFilters(state, filters) {
    state.filters = filters
  },
  setManageAutomatedTasks(state, automatedTasks) {
    state.manageAutomatedTasks = automatedTasks
  },
  setManageAutomatedTasksUnsubscribe(state, method) {
    state.manageAutomatedTasksUnsubscribe = method
  },
  setManageCompanies(state, operators) {
    state.manageCompanies = operators
  },
  setManageCompaniesUnsubscribe(state, method) {
    state.manageCompaniesUnsubscribe = method
  },
  setManageOperators(state, operators) {
    state.manageOperators = operators
  },
  setManageOperatorsUnsubscribe(state, method) {
    state.manageOperatorsUnsubscribe = method
  },
  setUser(state, user) {
    if (user && user !== 'unselect') {
      // Si hay un usuario actual y tiene substitutionsToday, hacer backup antes de cambiar
      if (
        state.user &&
        state.user.substitutionsToday?.length > 0 &&
        !state.userSubstitute &&
        user.id !== state.user.id
      ) {
        state.userSubstitute = lodash.cloneDeep(state.user)
      }
      state.user = user // asignar el nuevo usuario (el usuario ausente)
    } else {
      // Si user es 'unselect' (switch-off), restaurar el user original desde el backup
      if (user === 'unselect') {
        if (state.userSubstitute) {
          state.user = lodash.cloneDeep(state.userSubstitute)
          state.userSubstitute = null // ya no está en modo sustituto
        } else {
          console.log('error no esperado al restablecer el usuario')
          state.user = null
        }
      } else {
        // puede venir null, por ejemplo al hacer logout
        state.user = user
      }
    }
  },
  setPlan(state, plan) {
    state.plan = plan
  },
  setPlanUnsubscribe(state, method) {
    state.planUnsubscribe = method
  },
  setNews(state, news) {
    state.news = news
  },
  setNewsUnsubscribe(state, method) {
    state.newsUnsubscribe = method
  },
  setNotifications(state, { notifications, reloaded }) {
    state.notifications = notifications
    state.notificationsReloaded = reloaded === true
  },
  consumeNotificationsReloaded(state) {
    state.notificationsReloaded = false
  },
  updateNotificationManager(state, { id, manager }) {
    const notif = state.notifications.find((n) => n.id === id)
    if (notif) {
      notif.manager = manager
    }
  },
  setNotificationsUnsubscribe(state, method) {
    state.notificationsUnsubscribe = method
  },
  setSignatures(state, signatures) {
    state.signatures = signatures
  },
  setSignaturesUnsubscribe(state, method) {
    state.signaturesUnsubscribe = method
  },
  setNotificationsListOptions(state, options) {
    state.notificationsListOptions = options
  },
  setNotificationsSearch(state, search) {
    state.notificationsSearch = search
  },
  setNotificationsAdvancedSearch(state, advancedSearch) {
    state.notificationsAdvancedSearch = advancedSearch
  },
  setNotificationsCurrentPeriod(state, currentPeriod) {
    state.notificationsCurrentPeriod = currentPeriod
  },
  setNotificationsReloaded(state, reloaded) {
    state.notificationsReloaded = reloaded
  },
  setNotificationNavigationContext(state, value) {
    state.notificationNav = value
  },
  setNotificationNavIndex(state, index) {
    state.notificationNav.index = index
  },
  setUnregisteredNotificationsReload(state) {
    state.unregisteredNotificationsReload = Date.now()
  },
  setLastRetrievedNotificationsUnregistered(state, { user, newValue }) {
    if (user) {
      state.user.lastRetrievedNotificationsUnregistered = newValue
    }
  },
  setSignaturesListOptions(state, search) {
    state.signaturesListOptions = search
  },
  setSignaturesSearch(state, search) {
    state.signaturesSearch = search
  },
  setNavigationPages(state, navigationPages) {
    state.navigationPages = navigationPages
  },
  setRemoteAppVersion(state, remoteAppVersion) {
    state.remoteAppVersion = remoteAppVersion
  },
  setMaintenanceMode(state, maintenanceMode) {
    state.maintenanceMode = maintenanceMode
  },
  setContractModel(state, contractModel) {
    state.contractModel = contractModel
  },
  setAppBilling(state, billing) {
    state.billing = billing
  },
  setPending(state, pending) {
    state.pending = { ...state.pending, ...pending }
  },
  setAppWebManual(state, appWebManual) {
    state.appWebManual = appWebManual || false
  },
  setMassiveActionsSettings(state, settings) {
    state.massiveActionsSettings = settings
  },
  addListener(state, listener) {
    state.arrayListener.push(listener)
  },
  killListenersMutation(state) {
    // Matamos los listener del usuario
    if (state.newsUnsubscribe) state.newsUnsubscribe()
    if (state.notificationsUnsubscribe) state.notificationsUnsubscribe()
    if (state.signaturesUnsubscribe) state.signaturesUnsubscribe()
    if (state.planUnsubscribe) state.planUnsubscribe()

    // Matamos los listener creados para el apartado Gestión
    if (state.manageAutomatedTasksUnsubscribe)
      state.manageAutomatedTasksUnsubscribe()
    if (state.manageCompaniesUnsubscribe) state.manageCompaniesUnsubscribe()
    if (state.manageOperatorsUnsubscribe) state.manageOperatorsUnsubscribe()

    for (let i = 0; i < state.arrayListener.length; i++) {
      const listener = state.arrayListener[i]
      listener()
    }
  },
  resetState(state) {
    state.notFound = false
    state.navigationDrawer = false
    state.snackbar = {}
    state.dialog = {}
    state.progress = []
    //state.brand = null - NO SE MODIFICA PARA PRESERVAR SI NO SE DA F5
    state.filters = null
    state.manageAutomatedTasks = null
    state.manageAutomatedTasksUnsubscribe = () => {}
    state.manageCompanies = null
    state.manageCompaniesUnsubscribe = () => {}
    state.manageOperators = null
    state.manageOperatorsUnsubscribe = () => {}
    state.user = null
    state.userSubstitute = null
    state.plan = null
    state.planUnsubscribe = () => {}
    state.loading = false
    //state.maintenanceMode = false - NO SE MODIFICA PARA PRESERVAR TRAS LOGOUT FORZADO
    state.navigationPages = {}
    state.notifications = []
    state.notificationsUnsubscribe = () => {}
    state.signatures = []
    state.signaturesUnsubscribe = () => {}
    state.news = []
    state.newsUnsubscribe = () => {}
    state.notificationsListOptions = {}
    state.notificationsSearch = ''
    state.notificationsAdvancedSearch = ''
    state.notificationsCurrentPeriod = ''
    state.unregisteredNotificationsReload = 0
    state.signaturesListOptions = {}
    state.signaturesSearch = ''
    state.localAppVersion = process.env.VUE_APP_VERSION
    state.remoteAppVersion = ''
    state.contractModel = ''
    state.arrayListener = []
    state.billing = ''
    state.appWebManual = false
    state.msalInstance = null
    state.massiveActionsSettings = {}
  },
  resetProgress(state) {
    state.progress = []
  },
  setMsalInstance(state, msalInstance) {
    state.msalInstance = msalInstance
  },
  setExternalAuthConfig(state, externalAuthConfig) {
    state.externalAuthConfig = externalAuthConfig
  },
}

export default mutations
